import AdminEmotes from './AdminEmotes';

export default AdminEmotes;
